var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_14)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_116_14",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H0V22H22V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_116_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 11.0001C16.0001 10.4477 15.5524 10 15 10H7.00004C6.44777 10 6 10.4477 6 11.0001C6 11.5523 6.44777 12 7.00004 12H15C15.5524 12 16.0001 11.5523 16.0001 11.0001Z",
    fill: "#C91616"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92485 17.0751 0 11 0C4.9249 0 0 4.92485 0 11C0 17.0751 4.9249 22 11 22ZM11 19.9932C6.03319 19.9932 2.00683 15.9668 2.00683 11C2.00683 6.03321 6.03319 2.00683 11 2.00683C15.9668 2.00683 19.9932 6.03321 19.9932 11C19.9932 15.9668 15.9668 19.9932 11 19.9932Z",
    fill: "#C91616"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.0f1a09d8f2b3598347761fe752a198b5.svg";
export { ForwardRef as ReactComponent };